// Type-only: the root barrel re-exports this file, so a value import here
// closes a cycle and leaves the namespace half-initialized at runtime —
// `addressesFromIntentMetadata` reads back as undefined in consumers.
import type {
  ICreateCustomInvoiceItemDTO,
  ICreateInvoiceItemDTO
} from '../../index';
import type Stripe from 'stripe';

export * from './gateway';
export * from './intent-address-metadata';

export type InvoiceAndSubscribeStripeParams = {
  gateway: 'stripe';
  stripeId: string;
  items: (ICreateInvoiceItemDTO | ICreateCustomInvoiceItemDTO)[];
  orderId: string;
  chargeImmediately: boolean;
  paymentMethodId?: string;
  pauseCollection?: boolean;
  dueDate?: string;
};

export type InvoiceAndSubscribeNmiParams = {
  gateway: 'nmi';
  planId: string;
  customerId: string;
  orderId: string;
  startDate: Date;
  price: number;
};

export type AttachDefaultPaymentMethodParams = {
  gateway: 'nmi' | 'stripe';
  vaultId: string;
  paymentMethodToken: string;
  zip?: string;
};

export type GetPriceStripeParams = {
  gateway: 'stripe';
  sku: string;
};

export type GetPriceNmiParams = {
  gateway: 'nmi';
};

export type UpdateInvoiceStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
  stripeParams: Stripe.InvoiceUpdateParams;
};

export type UpdateInvoiceNmiParams = {
  gateway: 'nmi';
  nmiParams: any; // UpdateInvoiceRequest; // TODO: fix this, should not import from lib/adapters
};

export type PayInvoiceWithPaymentMethodStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
  paymentMethodId: string;
};

export type PayInvoiceWithPaymentMethodNmiParams = {
  gateway: 'nmi';
};

export type GetAllCustomerInvoicesStripeParams = {
  gateway: 'stripe';
  stripeId: string;
};

export type GetAllCustomerInvoicesNmiParams = {
  gateway: 'nmi';
  customerId: string;
};

export type ListInvoicesStripeParams = {
  gateway: 'stripe';
  stripeParams: Stripe.InvoiceListParams;
};

export type ListInvoicesNmiParams = {
  gateway: 'nmi';
  nmiParams: {
    customerId?: string;
    status?: any; // TransactionQuery['invoice_status']; // TODO: fix this, should not import from lib/adapters
  };
};

export type PayInvoiceStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
};

export type PayInvoiceNmiParams = {
  gateway: 'nmi';
};

export type GetInvoicePaymentMethodStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
};

export type GetInvoicePaymentMethodNmiParams = {
  gateway: 'nmi';
  invoiceId: string;
};

export type GetCustomerByEmailStripeParams = {
  gateway: 'stripe';
  email: string;
};

export type GetCustomerByEmailNmiParams = {
  gateway: 'nmi';
  email: string;
};

export type UpsertCustomerStripeParams = {
  gateway: 'stripe';
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  cardToken?: string;
  metadata?: any;
};

export type UpsertCustomerNmiParams = {
  gateway: 'nmi';
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  ccnumber: string;
  ccexp: string;
};

export type GetPaymentIntentStripeParams = {
  gateway: 'stripe';
  paymentIntentId: string;
};

export type CapturePaymentIntentStripeParams = {
  gateway: 'stripe';
  paymentIntentId: string;
};

export type CapturePaymentIntentNmiParams = {
  gateway: 'nmi';
  paymentIntentId: string;
};

export type AuthorizeConnectTokenStripeParams = {
  gateway: 'stripe';
  token: string;
};

export type AuthorizeConnectTokenNmiParams = {
  gateway: 'nmi';
  customerId: string;
};

export type GetInvoiceStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
};

export type GetInvoiceNmiParams = {
  gateway: 'nmi';
  invoiceId: string;
};

export type VoidInvoiceStripeParams = {
  gateway: 'stripe';
  invoiceId: string;
};

export type VoidInvoiceNmiParams = {
  gateway: 'nmi';
  invoiceId: string;
};

export type GetPaymentMethodsByEmailStripeParams = {
  gateway: 'stripe';
  email: string;
};

export type GetPaymentMethodsByEmailNmiParams = {
  gateway: 'nmi';
  email: string;
};

export interface IPaymentIntent extends Stripe.PaymentIntent {}
export interface IPaymentIntentLineItem extends Stripe.InvoiceLineItem {}
